const KEYS = {
  bannerShown: "swift_banner_shown",
} as const;

interface BannerShownRecord {
  id: string;
  shownAt: number;
  updatedAt: string;
}

export function getBannerShownRecord(
  bannerId: string,
): BannerShownRecord | null {
  const raw = localStorage.getItem(`${KEYS.bannerShown}_${bannerId}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as BannerShownRecord;
  } catch {
    return null;
  }
}

export function setBannerShown(bannerId: string, updatedAt: string): void {
  const record: BannerShownRecord = {
    id: bannerId,
    shownAt: Date.now(),
    updatedAt,
  };
  localStorage.setItem(
    `${KEYS.bannerShown}_${bannerId}`,
    JSON.stringify(record),
  );
}

export function shouldShowBanner(bannerId: string, updatedAt?: string): boolean {
  const record = getBannerShownRecord(bannerId);
  if (!record) return true;

  if (updatedAt) {
    const payloadDate = new Date(updatedAt).getTime();
    const storedDate = new Date(record.updatedAt).getTime();
    return payloadDate > storedDate;
  }

  const daysSinceShown = (Date.now() - record.shownAt) / (1000 * 60 * 60 * 24);
  return daysSinceShown > 1;
}
